<template>
  <ls-drawer
    title="发起变更单"
    width="85%"
    :visible="visible"
    @close="onCancel"
    :destroy-on-close="true"
  >
    <a-form-model
      class="changeFormCss"
      :model="formData"
      ref="changeForm"
    >
      <a-row>
        <a-col :md="8" :sm="24">
          <a-form-model-item
            label="发起类型"
            :labelCol="{ style: 'width: 120px;float:left' }"
            :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
            prop="initiationType"
            :rules="rules.initiationType"
          >
            <a-select style="width: 100%" v-model="formData.initiationType" :allowClear='false' @change="onChangeInitiationType">
              <a-select-option v-for="(item, index) in initiationTypeList" :key="item.value+'-'+index" :value="item.value" :label="item.label">
                {{ item.label }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :md="8" :sm="24">
          <a-form-model-item
            label="来源单号"
            :labelCol="{ style: 'width: 120px;float:left' }"
            :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
            prop="changeNo"
          >
            <a-input :disabled="true" v-model="formData.changeNo" />
          </a-form-model-item>
        </a-col>
        <a-col :md="8" :sm="24">
          <a-form-model-item
            label="变更主题"
            :labelCol="{ style: 'width: 120px;float:left' }"
            :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
            prop="changeSubject"
            :rules="rules.changeSubject"
          >
            <a-input v-model="formData.changeSubject" :maxLength="100" />
          </a-form-model-item>
        </a-col>
        <a-col :md="8" :sm="24">
          <a-form-model-item
            label="变更原因"
            :labelCol="{ style: 'width: 120px;float:left' }"
            :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
            prop="changeReason"
            :rules="rules.changeReason"
          >
            <a-input v-model="formData.changeReason" :maxLength="100" />
          </a-form-model-item>
        </a-col>
        <a-col :md="8" :sm="24">
          <a-form-model-item
            label="变更附件"
            :labelCol="{ style: 'width: 120px;float:left' }"
            :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
            prop="filePathList"
          >
            <ls-image-upload
              v-model="filePathList"
              :size="50"
              :OSS="OSS"
              :ossUploadApi="getToken"
              :need-tip="false"
              :uploadConfig="{ limitSize: 50, limitNumber: 30, accept: accept }"
            />
          </a-form-model-item>
        </a-col>
      </a-row>
      <div>
        <lsMetable
          ref="baseTable"
          class="changeTable"
          :columns="showColumns"
          :tableProps="{}"
          :data-list="formData.changeBillDetailList"
          :pagination="false"
          :IsEdit="false"
          :needAdd="false"
          :scroll="{ y: 500, extraHeight: 70, x: 1200 }"
          bordered
        >
          <!--变更类型-->
          <template slot="changeType" slot-scope="{ text, record, index }">
            <a-form-model-item :prop="'changeBillDetailList.' + index + '.changeType'" :rules="requiredRules">
              <a-select
                :allowClear="false"
                show-search
                style="width: 100%"
                :dropdown-match-select-width="false"
                option-filter-prop="children"
                v-model="record.changeType"
                option-label-prop="label">
                <a-select-option v-for="(item, index) in dynamicChangeTypes" :key="item.value+'-'+index" :value="item.value" :label="item.label">
                  {{ item.label }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </template>
          <!--变更数量-->
          <template slot="changeQuantity" slot-scope="{ text, record, index }">
            <a-form-model-item :prop="'changeBillDetailList.' + index + '.changeQuantity'" :rules="requiredRules">
              <a-input-number
                style="width: 100%"
                v-model="record.changeQuantity"
                :min="0"
                :max="999999"
                :formatter="(value) => `${value}`.replace(/^(\-)*(\d+)\.(\d{4}).*$/, '$1$2.$3', '')"
                :parser="(value) => value.replace(/^(\-)*(\d+)\.(\d{4}).*$/, '$1$2.$3', '')"
              />
            </a-form-model-item>
          </template>
          <!--变更交期-->
          <template slot="changePlanCycle" slot-scope="{ text, record, index }">
            <a-form-model-item :prop="'changeBillDetailList.' + index + '.changePlanCycle'" :rules="[{ required: record.changeType===10, message: ' ', trigger: 'change' }]">
              <a-month-picker style="width: 100%" v-model="record.changePlanCycle" :disabled-date="disabledDate" valueFormat="YYYY-MM" />
            </a-form-model-item>
          </template>
          <!--是否考核-->
          <template slot="assessorIs" slot-scope="{ text, record, index }">
            <a-form-model-item :prop="'changeBillDetailList.' + index + '.assessorIs'" :rules="requiredRules">
              <a-select style="width: 100%" v-model="record.assessorIs" :allowClear="false" @change="(val) => onChangeAssessorIs(val, record, index)">
                <a-select-option value="13">考核</a-select-option>
                <a-select-option value="14">不考核</a-select-option>
              </a-select>
            </a-form-model-item>
          </template>
          <!--责任方-->
          <template slot="responsibleParty" slot-scope="{ text, record, index }">
            <a-form-model-item :prop="'changeBillDetailList.' + index + '.responsibleParty'" :rules="requiredRules">
              <a-select
                :dropdown-match-select-width="false"
                style="width: 100%"
                v-model="record.responsibleParty"
                :allowClear="false"
                @change="(val) => onChangeResponsibleParty(val, record, index)">
                <a-select-option :value="10" :disabled="record.assessorIs==='13'">林氏</a-select-option>
                <a-select-option :value="11">成品供应商</a-select-option>
                <a-select-option :value="12">零部件供应商</a-select-option>
                <a-select-option :value="13">材料供应商</a-select-option>
              </a-select>
            </a-form-model-item>
          </template>
          <!--考核方-->
          <template slot="assessor" slot-scope="{ text, record, index }">
            <a-form-model-item :prop="'changeBillDetailList.' + index + '.assessor'" :rules="requiredRules">
              <a-select
                v-if="record.responsibleParty===10"
                allowClear
                show-search
                style="width: 100%"
                option-filter-prop="children"
                v-model="record.assessor"
                option-label-prop="label">
                <a-select-option v-for="(item, index) in ['林氏']" :key="item+index" :value="item" :label="item">
                  {{ item }}
                </a-select-option>
              </a-select>
              <a-select
                allowClear
                v-else
                show-search
                :dropdown-match-select-width="false"
                style="width: 100%"
                option-filter-prop="children"
                v-model="record.assessor"
                option-label-prop="label">
                <a-select-option v-for="item in searchCompanys" :key="item.id" :value="item.companyName" :label="item.companyName">
                  {{ item.companyName }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </template>
          <!--变更原因-->
          <template slot="changeReason" slot-scope="{ text, record, index }">
            <a-form-model-item :prop="'changeBillDetailList.' + index + '.changeReason'" :rules="requiredRules">
              <a-select
                allowClear
                show-search
                style="width: 100%"
                :dropdown-match-select-width="false"
                option-filter-prop="children"
                v-model="record.changeReason"
                option-label-prop="label">
                <a-select-option v-for="(item, index) in dynamicChangeReasons(record.responsibleParty)" :key="item.changeReason+index" :value="item.changeReason" :label="item.changeReason">
                  {{ item.changeReason }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </template>
          <!--执行日期-->
          <template slot="pricingDate" slot-scope="{ text, record, index }">
            <a-form-model-item :prop="'changeBillDetailList.' + index + '.pricingDate'" :rules="requiredRules">
              <a-date-picker
                :allowClear="false"
                style="width: 100%"
                v-model="record.pricingDate"
                :disabled-date="disabledDate"
                @change="(val) => onChangePricingDate(val, record, index)"
                valueFormat="YYYY-MM-DD 00:00:00" />
            </a-form-model-item>
          </template>
          <!--        <template slot="footer">
                    <a-table
                      bordered
                      :row-key="(record, index) => index"
                      :showHeader="false"
                      class="footerTable"
                      size="small"
                      :columns="footerTableColumns"
                      :data-source="sumInfoList"
                      :pagination="false"
                    >
                      <template #summation>
                        <span>合计</span>
                      </template>
                      <template #changeQuantity>{{ sumChangeQuantity }}</template>
                    </a-table>
                  </template>-->
        </lsMetable>
      </div>
    </a-form-model>
    <div class="footer">
      <a-space>
        <a-button @click="onCancel">取消</a-button>
        <a-button type="primary" @click="onSubmit" :loading="btnLoading">确认</a-button>
      </a-space>
    </div>
  </ls-drawer>
</template>

<script>
import {
  apiConfirmPlanPoolChangeBill,
  apiGetPlanPoolChangeBillDetailList,
  getAssessorGetList,
  apiGetPlanPoolPriceDetailList,
  getChangeReasonList
} from '@/api/scp/month-plan-pool/month-plan-pool'
import OSS from 'ali-oss';
import { apiMomGetToken } from "@/services/module/base";
import { LS_INITIATIVE_COLUMNS, INITIATIVE_PRICE_CHANGE_COLUMNS, CHANGE_TYPE_ENUM, INITIATION_TYPE_ENUM } from '../common'
import { fixedTable } from "lsmy-libs";
import cloneDeep from 'lodash.clonedeep';

const changeTypes = Object.values(CHANGE_TYPE_ENUM).map(item => ({ value: item.value, label: item.label }));
const initiationTypes = Object.values(INITIATION_TYPE_ENUM).map(item => ({ value: item.value, label: item.label }));

export default {
  name: 'PurchaseChangeDrawer',
  data () {
    this.OSS = OSS;
    this.getToken = apiMomGetToken;
    return {
      accept: '.jpg,.jpeg,.gif,.webp,.bmp,.png,.doc,docx,.xls,.xlsx,.ppt,.pptx,.pdf',
      searchCompanys: [], // 考核方下拉数据
      changeReasonList: [],
      // 变更类型
      changeTypeList: changeTypes,
      initiationTypeList: initiationTypes,
      selectData: [], // 列表选择的数据
      filePathList: [],
      visible: false,
      btnLoading: false,
      sumChangeQuantity: 0,
      formData: {
        initiationType: "", // 发起类型
        changeNo: '', // 变更单号
        changeSubject: '', // 变更主题
        changeReason: '', // 变更原因
        changeBillDetailList: [
          {
            changeQuantity: '', // 变更数量
            changeType: '', // 变更类型
            changePlanCycle: '', // 变更交期
            assessorIs: '', // 考核方是否
            responsibleParty: '', // 责任方
            changeReason: '', // 变更原因
            assessor: '', // 考核方
            pricingDate: '', // 执行日期
            detailList: [] // 记录价格数据
          }
        ]
      },
      orginalData: {}, // 原始数据
      sumInfoList: [{ reportIndex: '合计' }],
      requiredRules: [{ required: true, message: ' ', trigger: 'change' }],
      rules: {
        initiationType: [{ required: true, message: ' ', trigger: 'change' }],
        changeSubject: [{ required: true, message: ' ', trigger: 'change' }],
        changeReason: [{ required: true, message: ' ', trigger: 'change' }]
      },
      columns: LS_INITIATIVE_COLUMNS
    }
  },
  mixins: [ fixedTable ],
  computed: {
    footerTableColumns () {
      return [
        {
          title: '合计',
          scopedSlots: { customRender: 'summation' },
          align: 'center',
          width: 60,
          stickyFixed: 'left'
        },
        ...this.showColumns.slice(1)
      ]
    },
    // 显示的列
    showColumns() {
      return this.formData.initiationType === '11' ? INITIATIVE_PRICE_CHANGE_COLUMNS : LS_INITIATIVE_COLUMNS
    },
    // 根据发起方和责任方动态获取变更原因
    dynamicChangeReasons() {
      return (responsibleParty) => {
        let finallyList = this.changeReasonList
        if(this.formData.initiationType && responsibleParty) {
          // 根据发起类型过滤
          finallyList = this.changeReasonList.filter(item => item.initiationType === Number(this.formData.initiationType))
          // 根据责任方过滤
          finallyList = finallyList.filter(item => item.responsibleParty === responsibleParty)
          return finallyList
        } else {
          return []
        }
      }
    },
    // 动态变更类型下拉
    dynamicChangeTypes() {
      if(this.formData.initiationType === '11') {
        return this.changeTypeList.filter(item => item.value === 13) // 价格变更
      } else {
        return this.changeTypeList
      }
    }
  },
  methods: {
    // 获取考核方
    getAssessor() {
      const params = {
        supplierCode: this.selectData[0].supplierCode,
        pageSize: 999,
        page: 1
      }
      this.searchCompanys = [];
      getAssessorGetList(params).then(res => {
        if (res?.code === 200 && res?.data?.length > 0) {
          const uniqueNames = new Set();
          // 去重（接口有可能返回重复数据）
          this.searchCompanys = res.data.filter(item => {
            const key = item.companyName || '';
            if (uniqueNames.has(key)) return false;
            uniqueNames.add(key);
            return true;
          });
        }
      })
    },
    // 批量修改执行日期
    batchChangePricingDate() {
      const params = []
      this.formData.changeBillDetailList.forEach(item => {
        const param = {
          materialNo: item.itemCode,
          factoryCode: item.supplierCode,
          effectiveDate: item.pricingDate,
          sourceRowId: item.sourceRowId, // 计划单id
          planBusinessType: item.planBusinessType,
          changeGradePlace: item.originalTriggerLevel
        }
        params.push(param)
      })
      apiGetPlanPoolPriceDetailList(params).then(res => {
        // 和后端确认，变化执行日期，需变化签价仓库、变更价格、变更档位
        if (res?.code === 200) {
          if(res?.data?.length > 0) {
            this.formData.changeBillDetailList.forEach((item, index) => {
              const getData = res.data.find(val => val.sourceRowId === item.sourceRowId)
              this.changeData(index, getData)
            })
          }
        }
      })
    },
    // 变化执行日期
    onChangePricingDate(val, record, index) {
      const params = [{
        materialNo: record.itemCode,
        factoryCode: record.supplierCode,
        effectiveDate: val,
        sourceRowId: record.sourceRowId, // 计划单id
        planBusinessType: record.planBusinessType,
        changeGradePlace: record.originalTriggerLevel
      }]
      apiGetPlanPoolPriceDetailList(params).then(res => {
        // 和后端确认，变化执行日期，需变化签价仓库、变更价格、变更档位
        if (res?.code === 200) {
          if(res?.data?.length > 0) {
            this.changeData(index, res.data[0])
          } else {
            this.$set(this.formData.changeBillDetailList[index], 'warehouseName', '')
            this.$set(this.formData.changeBillDetailList[index], 'warehouseCode', '')
            this.$set(this.formData.changeBillDetailList[index], 'changePrice', '')
            this.$set(this.formData.changeBillDetailList[index], 'actualTriggerLevel', '')
          }
        }
      })
    },
    changeData(index, data) {
      if(data) {
        this.$set(this.formData.changeBillDetailList[index], 'detailList', [data]) // 每行价格只有一条
        this.$set(this.formData.changeBillDetailList[index], 'warehouseName', data.warehouseName)
        this.$set(this.formData.changeBillDetailList[index], 'warehouseCode', data.warehouseCode)
        this.$set(this.formData.changeBillDetailList[index], 'changePrice', data.taxUnitPrice)
        this.$set(this.formData.changeBillDetailList[index], 'actualTriggerLevel', data.changeGradePlace)
      }
    },
    // 获取变更原因
    getChangeReason(val) {
      this.changeReasonList = [];
      getChangeReasonList({ initiationType: val }).then(res => {
        if (res?.code === 200 && res?.data?.length > 0) {
          this.changeReasonList = res.data;
        }
      })
    },
    // 发起类型变化
    onChangeInitiationType(val) {
      if(val) {
        this.getChangeReason(val)
        // 切换发起类型重置一下列表数据
        let list = cloneDeep(this.orginalData?.changeBillDetailList || [])
        list = list.map(item => {
          // 执行日期默认为当前日期
          item.pricingDate = val === '11' ? this.$moment(new Date()).format('YYYY-MM-DD 00:00:00') : (item.pricingDate || '');
          return item
        })
        this.$set(this.formData, 'changeBillDetailList', list)
        // 触发执行日期查询价格接口
        if(val === '11' && list?.length > 0) {
          this.batchChangePricingDate()
        }
      }
    },
    // 要求到货时间-选择限制当前和以后日期
    disabledDate (current) {
      return current && current <= this.$moment().subtract(1, 'day');
    },
    async show (data) {
      this.selectData = data // 暂存选择的数据
      this.reset();
      this.getPurchaseChangeData(data)
      // 这里固定还要改改，有可能会动态调整
      // this.$nextTick(() => {
      //   this.setScroll();
      //   this.stickyFixedColumns(this.showColumns)
      //   this.stickyFixedColumns(this.footerTableColumns)
      //   // this.handleSearch()
      // })
    },
    // 是否考核变化
    onChangeAssessorIs(val, row, index) {
      this.$set(this.formData.changeBillDetailList[index], 'responsibleParty', '')
      this.$set(this.formData.changeBillDetailList[index], 'assessor', '')
      this.$set(this.formData.changeBillDetailList[index], 'changeReason', '')
    },
    // 责任方变化
    onChangeResponsibleParty(val, row, index) {
      this.$set(this.formData.changeBillDetailList[index], 'assessor', '')
      this.$set(this.formData.changeBillDetailList[index], 'changeReason', '')
      if(val === 10) { // 林氏
        this.$set(this.formData.changeBillDetailList[index], 'assessor', '林氏')
      } else if(val === 11) { // 成品供应商
        this.$set(this.formData.changeBillDetailList[index], 'assessor', this.selectData[0].supplierName)
      }
    },
    // 初始化获取数据
    async getPurchaseChangeData (data) {
      const res = await apiGetPlanPoolChangeBillDetailList(data.map(val => val.id));
      if (res.code === 200 && res.data?.length > 0) {
        this.getAssessor()
        const data = res.data[0];
        this.orginalData = cloneDeep(data)
        this.formData = data;
        this.visible = true
      }
    },
    onCancel () {
      this.reset();
      this.visible = false
    },
    //  重置
    reset () {
      this.formData = {
        initiationType: "", // 发起类型
        changeNo: '', // 变更单号
        changeSubject: '', // 变更主题
        changeReason: '', // 变更原因
        changeBillDetailList: [
          {
            changeQuantity: '', // 变更数量
            changeType: '', // 变更类型
            changePlanCycle: '', // 变更交期
            assessorIs: '', // 考核方是否
            responsibleParty: '', // 责任方
            changeReason: '', // 变更原因
            assessor: '', // 考核方
            pricingDate: '', // 执行日期
            detailList: [] // 记录价格数据
          }
        ]
      };
      this.filePathList = []
      if(this.$refs?.changeForm) this.$refs.changeForm.resetFields()
    },
    // 验证表单
    checkValidate () {
      let flag = true
      this.$refs.changeForm.validate(valid => {
        flag = valid
      })
      return flag
    },
    // 提交
    onSubmit() {
      if (!this.checkValidate()) {
        this.$message.error('请填写必填项')
        return
      }
      this.btnLoading = true;
      const params = [
        {
          ...this.formData,
          fileUrl: this.filePathList.map(val => ({ attachPath: val.attachPath, attachName: val.attachName }))
        }
      ]
      apiConfirmPlanPoolChangeBill(params).then(res => {
        if (res?.code === 200) {
          this.$message.success('提交成功')
          this.$emit('successCall')
          this.onCancel()
        } else {
          this.$message.error('提交失败')
        }
      }).finally(() => {
        this.btnLoading = false;
      })
    }
    // 合并表格设置同步滚动
    // setScroll () {
    //   // 同步表与footer滚动
    //   const dom = this.$refs.baseTable.$el.querySelectorAll('.ant-table-body')[0]
    //   dom.addEventListener('scroll', () => {
    //     this.$refs.baseTable.$el.querySelectorAll('.ant-table-body')[1].scrollLeft = dom.scrollLeft
    //   }, true)
    // },
    // 合计要求到仓数量
    // getSumQuantity () {
    //   this.sumChangeQuantity = 0
    //   this.formData.changeBillDetailList.forEach(item => {
    //     this.sumChangeQuantity = Number(item.changeQuantity || 0) + Number(this.sumChangeQuantity)
    //   })
    // }
  },
  mounted () {
    // this.getSumQuantity()
  }
}
</script>
<style scoped lang="less">
@import '../../../../../components/StickyFixedSummary/styles/footerTable.less';
.form-area{
  /deep/.ant-form-item{
    width: 100%;
  }
  .ant-form-item-control-wrapper{
    width: 100%;
  }
}
.text-3-ellipsis {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
}
.changeTable{
  // margin-bottom: 100px;
  /deep/.ant-table-footer{
    padding: 0;
    border: none;
  }
  /deep/.ant-modal-body{
    // height: 600px;
    overflow-y: scroll;
  }
  /deep/.ant-form-item {
    margin-bottom: 0;
  }
  /deep/ .ant-form-explain, .ant-form-extra{
    min-height: 0;
    height: 0;
  }
}
.changeFormCss{
  /deep/.ant-form-item {
    margin-bottom: 0;
  }
  /deep/ .ant-form-explain, .ant-form-extra{
    min-height: 0;
    height: 0;
  }
}
.footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 4px 4px;
}
//.footerTable{
//  /deep/.ant-table-body{
//    margin: 0
//  }
//}

</style>
